import { render, staticRenderFns } from "./ListProductCarousel.vue?vue&type=template&id=396fb8ce&scoped=true"
import script from "./ListProductCarousel.vue?vue&type=script&lang=js"
export * from "./ListProductCarousel.vue?vue&type=script&lang=js"
import style0 from "./ListProductCarousel.vue?vue&type=style&index=0&id=396fb8ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396fb8ce",
  null
  
)

export default component.exports